import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SchemaRenderer } from 'volto-fzj-internet/components';
import { difference } from '@plone/volto/helpers';
import { replaceItemOfArray } from '@plone/volto/helpers';
import { usePrevious } from '@plone/volto/helpers';
import compact from 'lodash/compact';

import { SliderSchema } from './schema';

const SliderData = (props) => {
  const { block, data, onChangeBlock } = props;
  const intl = useIntl();
  const { slides } = props.data;
  const previous = usePrevious(slides);

  React.useEffect(() => {
    if (previous) {
      const diff = difference(slides, previous);
      const index = diff.findIndex((val) => val);
      const isReordering = compact(diff).length > 1;
      if (isReordering) return;
      if (diff[index]?.href?.[0]) {
        onChangeBlock(block, {
          ...data,
          slides: replaceItemOfArray(data.slides, index, {
            ...data.slides[index],
            title: diff[index].href[0].title,
            description: diff[index].href[0].Description,
            head_title: diff[index].href[0].head_title,
          }),
        });
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [slides]);

  return (
    <SchemaRenderer
      schema={SliderSchema({ ...props, intl })}
      title={SliderSchema({ ...props, intl }).title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      fieldIndex={data.index}
      basic
      unwrapped
      block={block}
    />
  );
};

SliderData.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  block: PropTypes.string.isRequired,
  onChangeBlock: PropTypes.func.isRequired,
};

export default SliderData;
